
import { defineComponent, ref, watch, onMounted, computed } from 'vue'
import { stockpool } from '@/api/index'
import { useRoute } from 'vue-router'

// 龙头猎手信号类型 -> nameType 映射
const TYPE_MAP: Record<string, string> = {
    dragonStar: 'dragonStar',
    dragonDouble: 'dragonDouble',
    overTaking: 'overTaking',
    dragonLeft: 'dragonLeft',
    dragonRight: 'dragonRight'
}

export default defineComponent({
    name: 'DragonHunterBacktest',
    props: {
        theme: { type: String, default: 'light' },
        // nameType: dragonStar/dragonDouble/overTaking/dragonLeft/dragonRight
        nameType: { type: String, default: 'dragonStar' }
    },
    setup(props) {
        const route = useRoute()
        const periodData = ref([
            { timeType: 30, label: '近1月', data: null as any },
            { timeType: 60, label: '近3月', data: null as any },
            { timeType: 90, label: '近1年', data: null as any }
        ])

        // 龙头加强时第一行标签是"二板后"，其他是"涨停后"
        const firstRowLabel = computed(() =>
            props.nameType === 'dragonDouble' ? '二板后区间平均最高涨幅' : '涨停后区间平均最高涨幅'
        )

        const fetchData = async () => {
            const nameType = TYPE_MAP[props.nameType] || 'dragonStar'
            try {
                const promises = periodData.value.map(item =>
                    stockpool.getDragonHunterDataFind({
                        data: { nameType, timeType: item.timeType },
                        headers: {
                            clienttype: 'pc',
                            appVersion: route.query.appVersion,
                            token: route.query.token
                        }
                    })
                )
                const results = await Promise.all(promises)
                periodData.value.forEach((item, index) => {
                    const res = results[index] as any
                    if (res?.data) item.data = res.data
                })
            } catch (e) {
                console.error('DragonHunterBacktest fetchData failed', e)
            }
        }

        watch(() => props.nameType, fetchData)
        onMounted(fetchData)

        const formatPercent = (val: number | null | undefined) => {
            if (val === null || val === undefined) return '--'
            return (val * 100).toFixed(2) + '%'
        }

        const getColorClass = (val: number | null | undefined) => {
            if (val === null || val === undefined || val === 0) return 'color-gray'
            return val > 0 ? 'color-red' : 'color-green'
        }

        return { periodData, firstRowLabel, formatPercent, getColorClass }
    }
})
